module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc2-02-0aec0fb1e60502ed9b438560a5a2ae7c.png";